import React, { useState } from 'react';
import SectionHeading from "../../../common/SectionHeading/SectionHeading";
import './Faq.css';

const Faq = () => {
  const faqlist = [
    {
      _id: "1",
      question: "Do you ship internationally or worldwide?",
      answer: "We provide insured express shipping to international destinations worldwide. We partner with premier global logistics couriers (including DHL Express and FedEx) to ensure prompt and secure delivery of your garments."
    },
    {
      _id: "2",
      question: "Can I cancel or modify my order?",
      answer: "You can request order cancellation within 24 hours of placement without any penalty fees. While we do not offer direct bank refunds on cancellations, our concierge team will promptly issue a store credit note redeemable within 7 days across any collection."
    },
    {
      _id: "3",
      question: "How long will it take for my order to arrive?",
      answer: "All pieces are inspected and dispatched directly from our central atelier in Kathmandu.\n\n• Domestic Orders (Nepal): Standard delivery takes 2–3 business days.\n• International Orders: Express delivery takes 7–20 business days depending on customs clearance.\n\nReal-time tracking links will be sent directly to your registered email and mobile number upon dispatch."
    },
    {
      _id: "4",
      question: "What payment methods do you accept?",
      answer: "We accept all major secure payment methods:\n\n• Net Banking & Direct Bank Transfers\n• Digital Wallets (eSewa, Khalti, ConnectIPS)\n\nAll transactions are encrypted with industry-standard 256-bit SSL protocols."
    },
    {
      _id: "5",
      question: "What should I do if my garment arrives damaged?",
      answer: "In the unlikely event that your piece arrives damaged or defective, please contact our Client Care team within 48 hours of delivery. We will immediately arrange a complimentary reverse courier pickup and dispatch a replacement garment."
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0); // First item open by default for immediate engagement

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="maya-faq-section" aria-label="Client Concierge and FAQs">
      <div className="maya-faq-container">
        {/* SECTION HEADER */}
        <SectionHeading
          title="Frequently Asked Questions"
          subtitle="Essential information regarding our collections, bespoke craftsmanship, worldwide shipping, and client care."
        />

        {/* 2-COLUMN CONCIERGE & ACCORDION GRID */}
        <div className="maya-faq-grid">
          {/* LEFT: STICKY CONCIERGE CARD */}
          <aside className="maya-faq-concierge-sticky">
            <div className="maya-faq-concierge-card">
              <div className="maya-faq-status-pill">
                <span className="maya-faq-status-dot" aria-hidden="true" />
                <span>Personal help, right here online</span>
              </div>

              <h3 className="maya-faq-concierge-heading">
                Need something tailored just for you?
              </h3>

              <p className="maya-faq-concierge-text">
                Our client advisory team is here to help with custom fittings and worldwide delivery questions.
              </p>

              <div className="maya-faq-concierge-actions">
                <a
                  href="https://wa.me/9766549770"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="maya-faq-btn-primary"
                >
                  <span>WhatsApp Concierge</span>
                  <span aria-hidden="true">→</span>
                </a>

                <a
                  href="mailto:wearsmaya@gmail.com"
                  className="maya-faq-btn-secondary"
                >
                  <span>Email Client Care</span>
                  <span aria-hidden="true">↗</span>
                </a>
              </div>
            </div>
          </aside>

          {/* RIGHT: ACCORDION LIST */}
          <div className="maya-faq-list" role="region" aria-label="FAQ Accordion">
            {faqlist.map((item, index) => {
              const isOpen = activeIndex === index;
              const formattedNumber = String(index + 1).padStart(2, "0");

              return (
                <div
                  key={item._id || index}
                  className={`maya-faq-item ${isOpen ? "is-active" : ""}`}
                >
                  <button
                    type="button"
                    className="maya-faq-trigger"
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${index}`}
                  >
                    <div className="maya-faq-trigger-content">
                      <span className="maya-faq-number">{formattedNumber}</span>
                      <h3 className="maya-faq-question">{item.question}</h3>
                    </div>

                    <span className="maya-faq-toggle-icon" aria-hidden="true">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                      </svg>
                    </span>
                  </button>

                  {/* Smooth height collapse */}
                  <div
                    id={`faq-answer-${index}`}
                    className={`maya-faq-collapse ${isOpen ? "is-open" : ""}`}
                  >
                    <div className="maya-faq-collapse-inner">
                      <p className="maya-faq-answer">{item.answer}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(Faq);